<template>
  <div>
    <v-card
      ><v-card-text>
        <menuSuperviseur />
        <v-card>
          <v-card-text>
            
            <template>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Projet</th>
                      <th class="text-left">Objectifs</th>
                      <th class="text-left">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in filterProject(projets)"
                      :key="index"
                    >
                      <td>{{ item.ll_programme }}</td>
                      <td>{{ item.objectifs }}</td>
                      <td style="width:150px">
                        <v-btn
                          outlined
                          x-small
                          fab
                          dark
                          class="success"
                          @click="detailsProjet(item)"
                        >
                          <v-icon>chevron_right</v-icon>
                        </v-btn>
                        <v-btn
                          @click="goToStats(item)"
                          outlined
                          x-small
                          fab
                          dark
                          class="green ml-2"
                        >
                          <v-icon>mdi-database-export-outline</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </template>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      regions: [],
      idProjet: null,
      ll_programme: "",
      objectifs: "",
      dialogProjet: false,
      dialogDeleteProjet: false,
      valid: true,
      nameRules: [
        (v) => !!v || "requis",
        (v) => (v && v.length >= 2) || "Au moins deux caractères",
      ],
    };
  },
  created() {
    if (!this.$route.params.bailleur) {
      console.log("pas de paramètres", this.$route.params.bailleur);

      this.$router.go(-1);
    }
    this.getBailleurs();
    this.GetThemes();
  },
  components: {
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    goToStats(item) {
      this.$router.push({
        path: "/superviseur/stats/StatsFormationsDeGroupe",
        query: item,
      });
    },
    filterProject(projets) {
      const idBailleur = this.$route.params.bailleur.id;
      //console.log(projets);
      return _.filter(projets, { bailleurs_id_bailleur: idBailleur });
    },
    detailsProjet(projet) {
      this.$router.push({
        name: "superviseur-rapports-projets-id",
        params: { projet },
      });
    },
    ...mapActions({
      getBailleurs: "Bailleurs/getListeBailleurs",
      getProjets: "Projets/getListeProjets",
      GetThemes: "Themes/GetAll",
    }),
  },
  computed: {
    ...mapState({
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      user: (state) => state.Auth.user,
      Activites: (state) => state.Activites.Activites,
      bailleurs: (state) => state.Bailleurs.bailleurs,
      projets: (state) => state.Projets.projets,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
